// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2QdBQ","imageUploader":"EGiftCard_imageUploader__1WkCj"};